import { render, staticRenderFns } from "./AvisoBloqueio.vue?vue&type=template&id=d88ef676&scoped=true&"
import script from "./AvisoBloqueio.vue?vue&type=script&lang=js&"
export * from "./AvisoBloqueio.vue?vue&type=script&lang=js&"
import style0 from "./AvisoBloqueio.vue?vue&type=style&index=0&id=d88ef676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88ef676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
